import { render, staticRenderFns } from "./Quadrado.vue?vue&type=template&id=4e3a066d&scoped=true&"
import script from "./Quadrado.vue?vue&type=script&lang=js&"
export * from "./Quadrado.vue?vue&type=script&lang=js&"
import style0 from "./Quadrado.vue?vue&type=style&index=0&id=4e3a066d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3a066d",
  null
  
)

export default component.exports